import React, { Fragment, useEffect } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Card,
  CardBody,
  ButtonToggle,
  CardFooter,
  CardHeader,
  Button,
  CardTitle,
  CardText,
  Table,
} from 'reactstrap';
import { connect, useSelector } from 'react-redux';
import classnames from 'classnames';
import STEP_ONE_BASIC_DETAILS from './STEP_ONE_BASIC_DETAILS';
import {
  DOCUMENT_GOTO_PREVIOUS_STEP,
  SET_DOCUMENT_FORM_AS_EDITABLE,
  DOCUMENT_GOTO_NEXT_STEP,
  RESET_DOCUMENT_BUILD_FORM,
  GOTO_SELECTED_STEP,
  SET_DOCUMENT_TYPE,
  SET_DOCUMENT_FORMAT,
  SAVE_VALUE,
  INSTRUCTION_SAVE_VALUE,
  INSTRUCTION_RESET_STATE,
  RESET_STATE,
  SET_AND_RESET_ADDITIONAL_DOCUMENTS,
} from '../../../redux/actions/ActionTypes';
import { bindActionCreators } from 'redux';
import STEP_TWO_BUILD_DOCUMENT from './STEP_TWO_BUILD_DOCUMENT';
import { useHistory, Link } from 'react-router-dom';
import { DOCUMENTS_PATH } from '../../../utils/AppRoutes';
import {
  getAlert,
  getAlertToast,
} from '../../../utils/functions/CustomFunctions';
import API from '../../../redux/actions/API';
import { authHeader } from '../../../utils/functions/CoreFunctions';
import {
  AGENCY_DOCUMENT_DETAILS_URL,
  AGENCY_DOCUMENT_UPDATE_URL,
} from '../../../utils/APIEndpoints';
import Swal from 'sweetalert2';
import { useState } from 'react';
import VariablesList from './VariablesList';
import Instructions from '../instructions/Instructions';
// import WebFormGenerator from './WebFormGenerator';
const WebFormGenerator = React.lazy(() => import('./WebFormGenerator'));

function CreateDocument(props) {
  const {
    match: {
      params: { id: agencyServiceId = '' },
    },
    location: { pathname = '', state = {} },
  } = props;
  let splittedPath = pathname.split('/')[1];

  let isDocumentEditFlow = false;
  if (splittedPath === 'edit-document') isDocumentEditFlow = true;

  const history = useHistory();
  const {
    CreateDocumentForm = {},
    dispatch,
    HandleDocumentType = {},
    HandleDocumentFormat = {},
  } = props;
  const { currentStep = 1, step2 = {}, step1 = {} } = CreateDocumentForm;
  const { allDocuments = [] } = step2;
  const { formInitialValues = {} } = step1;
  const { serviceAmount = 0 } = formInitialValues;
  const { paymentsType = '' } = HandleDocumentType;
  const { documentsType = '' } = HandleDocumentFormat;
  const [loading, setLoading] = useState(false);
  const from = useSelector((state) => state.FormReducer);
  const { formValues = [] } = from;
  //State
  const [isExpandedFeeView, setExpandedFeeView] = useState(false);
  const [webFormInstruction, setWebFormInstruction] = useState('');

  const feeDetailsToggle = () => {
    setExpandedFeeView(!isExpandedFeeView);
  };

  //Previous Step
  const goToPreviousStep = () => {
    dispatch({
      type: DOCUMENT_GOTO_PREVIOUS_STEP,
      payload:
        documentsType === 'WebForm' && currentStep == 6
          ? 4
          : paymentsType === 'Fixed' && currentStep == 3
          ? 2
          : currentStep,
    });
  };

  //Get Document Details
  const getDocumentDetails = async () => {
    try {
      const options = {
        method: 'GET',
        url: AGENCY_DOCUMENT_DETAILS_URL,
        headers: authHeader(),
        params: { agencyServiceId: parseInt(agencyServiceId) },
      };
      const response = await API(options);
      let apiResponse = response.data;
      const { status } = apiResponse;
      if (status === 'Success') {
        const {
          status: documentStatus = '',
          paymentType = '',
          documentType = '',
          isActive,
          instructions = [],
          templatePlaceHolderValue = [],
          requiredDocuments = '[]',
          formInstruction,
        } = apiResponse.data;

        const { moveToStep = '' } = state;

        setWebFormInstruction(formInstruction);

        if (documentStatus == 'New' || isActive == false) {
          dispatch({
            type: SET_DOCUMENT_FORM_AS_EDITABLE,
            payload: apiResponse.data,
            moveToStep: moveToStep || 1,
          });

          dispatch({
            type: SET_DOCUMENT_FORMAT,
            payload: documentType,
          });
          dispatch({
            type: SET_DOCUMENT_TYPE,
            payload: paymentType,
          });
          dispatch({
            type: SET_AND_RESET_ADDITIONAL_DOCUMENTS,
            payload: JSON.parse(requiredDocuments || '[]'),
          });

          if (instructions != null) {
            let instruction = JSON.parse(instructions || '[]');
            dispatch({
              type: INSTRUCTION_SAVE_VALUE,
              payload: instruction,
            });
          }

          if (documentType == 'WebForm' && isActive == false) {
            // const value = JSON.parse(
            //   templatePlaceHolderValue?.replace('', '.') || []
            // );
            let cleaned = templatePlaceHolderValue
            ? templatePlaceHolderValue.replace(/\u0019/g, "'")
              : "[]";
              console.log('cleaned text 2');
            const value = JSON.parse(cleaned || []);
            // const value = JSON.parse(templatePlaceHolderValue || []);
            const { elements = [] } = value[0];

            dispatch({
              type: SAVE_VALUE,
              payload: elements,
            });
          }
          // dispatch({
          //   type: SET_DOCUMENT_FORM_AS_EDITABLE,
          //   payload: apiResponse.data,
          //   moveToStep: moveToStep || 1,
          // });
        } else {
          Swal.fire(getAlert('error', 'You cannot access this document'));
          history.push(DOCUMENTS_PATH);
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        console.error(data,"data")
      }
    }
  };

  //Submit To Admin
  const submitDocumentToAdmin = async () => {
    try {
      let elementsCount = 0,
        varFee = 0;
      {
        allDocuments.map((document) =>
          document.elements.forEach(function ({ propertyType, variableFee }) {
            elementsCount += 1;
            if (propertyType === 'Variable') {
              varFee += variableFee;
            }
          })
        );
      }
      if (documentsType === 'WebForm') {
        // var JSONValue = JSON.stringify(formValues);
        var passData = JSON.stringify([
          { documentURL: '', elements: formValues },
        ]);
        try {
          let storeData = {
            agencyServiceId,
            isSubmitAdmin: true,
            templatePlaceHolderValue: passData,
            formInstruction: webFormInstruction ? webFormInstruction : '',
          };
          storeData.hyperlink = window.location.origin + '/admin/requests'; //Route Link For Login From Email
          const options = {
            method: 'PUT',
            url: AGENCY_DOCUMENT_UPDATE_URL,
            headers: authHeader(),
            data: storeData,
          };
          Swal.fire(getAlertToast('success', 'Please wait...'));
          var apiResponse = await API(options);
          const { status, message } = apiResponse.data;
          if (status === 'Error') {
            Swal.fire(getAlertToast('error', message));
          } else {
            Swal.fire(
              getAlert(
                'success',
                'Form submitted to Admin for review. You will be notified through email. '
              )
            );
            history.push(DOCUMENTS_PATH);
          }
        } catch (error) {
          if (error.response) {
            let { data } = error.response;
            console.error(data,"error")
            // Swal.fire(getAlertToast('error', data.message ));
          }
        }
      } else if (allDocuments.length == 0 && documentsType !== 'WebForm') {
        Swal.fire(getAlert('error', 'Please upload the document.'));
        dispatch({
          type: DOCUMENT_GOTO_PREVIOUS_STEP,
          payload: currentStep,
        });
      } else if (elementsCount == 0 && documentsType !== 'WebForm') {
        Swal.fire(getAlert('error', 'Please add atleast one placeholder.'));
        dispatch({
          type: DOCUMENT_GOTO_PREVIOUS_STEP,
          payload: currentStep,
        });
      } else if (documentsType == 'Variable' && varFee == 0) {
        Swal.fire(getAlert('error', 'Please add variable to this document.'));
        dispatch({
          type: DOCUMENT_GOTO_PREVIOUS_STEP,
          payload: currentStep,
        });
      } else {
        let storeData = {
          agencyServiceId,
          templatePlaceHolderValue: JSON.stringify(allDocuments),
          isSubmitAdmin: true,
          formInstruction: webFormInstruction ? webFormInstruction : '',
        };
        storeData.hyperlink = window.location.origin + '/admin/requests'; //Route Link For Login From Email
        const options = {
          method: 'PUT',
          url: AGENCY_DOCUMENT_UPDATE_URL,
          headers: authHeader(),
          data: storeData,
        };
        Swal.fire(getAlertToast('success', 'Please wait...'));
        var apiResponse = await API(options);
        const { status, message } = apiResponse.data;
        if (status === 'Error') {
          Swal.fire(getAlertToast('error', message));
        } else {
          Swal.fire(
            getAlert(
              'success',
              'Document submitted to Admin for review. You will be notified through email. '
            )
          );
          history.push(DOCUMENTS_PATH);
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
         Swal.fire(getAlertToast('error', data.message ));
      }
    }
  };

  //Did Mount
  useEffect(() => {
    if (agencyServiceId) {
      getDocumentDetails();
    } else {
      dispatch({
        type: SET_DOCUMENT_TYPE,
        payload: 'Fixed',
      });
      dispatch({
        type: INSTRUCTION_RESET_STATE,
      });
      dispatch({
        type: RESET_STATE,
      });
    }
  }, [agencyServiceId]);

  //Go to Selected Tab
  const onTabClick = (tabIndex) => {
    dispatch({
      type: GOTO_SELECTED_STEP,
      payload: tabIndex,
    });
  };

  //Fee List for Pdf
  let groupedVariablesArray = new Map();
  allDocuments.forEach((document) => {
    document.elements
      .filter((element) => element.propertyType === 'Variable')
      .forEach((item) => {
        const propertyValue = item['variableId'];
        groupedVariablesArray.has(propertyValue)
          ? groupedVariablesArray.set(propertyValue, {
              ...item,
              ...groupedVariablesArray.get(propertyValue),
            })
          : groupedVariablesArray.set(propertyValue, item);
      });
  });
  groupedVariablesArray = Array.from(groupedVariablesArray.values());

  // Fee list for Webform
  let groupedWebFormVariablesArray = new Map();
  formValues
    .filter(
      (document) =>
        document.type === 'variable' && document.label !== 'Field Label'
    )
    .forEach((item) => {
      const propertyValue = item['label'];
      groupedWebFormVariablesArray.has(propertyValue)
        ? groupedWebFormVariablesArray.set(propertyValue, {
            ...item,
            ...groupedWebFormVariablesArray.get(propertyValue),
          })
        : groupedWebFormVariablesArray.set(propertyValue, item);
    });
  groupedWebFormVariablesArray = Array.from(
    groupedWebFormVariablesArray.values()
  );

  useEffect(() => {
    if (isDocumentEditFlow && state) {
      const { moveToStep = '' } = state;
      dispatch({
        type: DOCUMENT_GOTO_NEXT_STEP,
        payload: moveToStep,
      });
    } else {
      dispatch({
        type: RESET_DOCUMENT_BUILD_FORM,
      });
    }
  }, []);

  return (
    <Fragment>
      <Card>
        <CardHeader>
          <CardTitle style={{ margin: '0' }}>
            Document
            <Link to={DOCUMENTS_PATH}>
              <Button className="f-r" color="primary">
                <i className="fas fa-arrow-left"></i> Back
              </Button>
            </Link>
          </CardTitle>
        </CardHeader>
        <CardBody>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames(
                  { active: parseInt(currentStep) === 1 },
                  isDocumentEditFlow ? 'cursorHand' : ''
                )}
                onClick={() => (isDocumentEditFlow ? onTabClick(1) : undefined)}
              >
                Basic Details
              </NavLink>
            </NavItem>
            {paymentsType === 'Fixed' && documentsType === 'WebForm' && (
              <>
                <NavItem>
                  <NavLink
                    className={classnames(
                      { active: parseInt(currentStep) === 3 },
                      isDocumentEditFlow ? 'cursorHand' : ''
                    )}
                    onClick={() =>
                      isDocumentEditFlow ? onTabClick(3) : undefined
                    }
                  >
                    Instructions
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames(
                      { active: parseInt(currentStep) === 6 },
                      isDocumentEditFlow ? 'cursorHand' : ''
                    )}
                    onClick={() =>
                      isDocumentEditFlow ? onTabClick(6) : undefined
                    }
                  >
                    WebForm Builder
                  </NavLink>
                </NavItem>
              </>
            )}

            {paymentsType === 'Variable' && (
              <NavItem>
                <NavLink
                  className={classnames(
                    { active: parseInt(currentStep) === 2 },
                    isDocumentEditFlow ? 'cursorHand' : ''
                  )}
                  onClick={() =>
                    isDocumentEditFlow ? onTabClick(2) : undefined
                  }
                >
                  Variables
                </NavLink>
              </NavItem>
            )}
            {paymentsType === 'Variable' && documentsType === 'WebForm' ? (
              <>
                <NavItem>
                  <NavLink
                    className={classnames(
                      { active: parseInt(currentStep) === 3 },
                      isDocumentEditFlow ? 'cursorHand' : ''
                    )}
                    onClick={() =>
                      isDocumentEditFlow ? onTabClick(3) : undefined
                    }
                  >
                    Instructions
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames(
                      { active: parseInt(currentStep) === 6 },
                      isDocumentEditFlow ? 'cursorHand' : ''
                    )}
                    onClick={() =>
                      isDocumentEditFlow ? onTabClick(6) : undefined
                    }
                  >
                    WebForm Builder
                  </NavLink>
                </NavItem>
              </>
            ) : (
              ''
            )}
            {documentsType === 'Pdf' ? (
              <>
                <NavItem>
                  <NavLink
                    className={classnames(
                      { active: parseInt(currentStep) === 3 },
                      isDocumentEditFlow ? 'cursorHand' : ''
                    )}
                    onClick={() =>
                      isDocumentEditFlow ? onTabClick(3) : undefined
                    }
                  >
                    Instructions
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames(
                      { active: parseInt(currentStep) === 4 },
                      isDocumentEditFlow ? 'cursorHand' : ''
                    )}
                    onClick={() =>
                      isDocumentEditFlow ? onTabClick(4) : undefined
                    }
                  >
                    Build Document
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames(
                      { active: parseInt(currentStep) === 5 },
                      isDocumentEditFlow ? 'cursorHand' : ''
                    )}
                    onClick={() =>
                      isDocumentEditFlow ? onTabClick(5) : undefined
                    }
                  >
                    Preview Document
                  </NavLink>
                </NavItem>
              </>
            ) : (
              ''
            )}
          </Nav>
          <br />
          <TabContent activeTab={parseInt(currentStep)}>
            <TabPane tabId={1}>
              <Row>
                <Col sm="12">
                  <STEP_ONE_BASIC_DETAILS setSubmitLoading={setLoading} />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={2}>
              <Row>
                <Col sm="12">
                  {/* Variable CRUD */}
                  <VariablesList
                    agencyServiceId={agencyServiceId}
                    documentsList={allDocuments}
                  />
                  {/* Variable CRUD */}
                </Col>
              </Row>
            </TabPane>

            <TabPane tabId={3}>
              <Row>
                <Col sm="12">
                  <Instructions />
                </Col>
              </Row>
            </TabPane>

            <TabPane tabId={4}>
              <Row>
                <Col sm="12">
                  <STEP_TWO_BUILD_DOCUMENT
                    isPreviewDocument={false}
                    documentsList={allDocuments}
                  />
                </Col>
              </Row>
            </TabPane>

            <TabPane tabId={5}>
              <Row>
                <Col sm="12">
                  <STEP_TWO_BUILD_DOCUMENT
                    isPreviewDocument={true}
                    documentsList={allDocuments}
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={6}>
              <Row>
                <Col sm="12">
                  <WebFormGenerator
                    webFormInstruction={webFormInstruction}
                    setWebFormInstruction={setWebFormInstruction}
                  />
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </CardBody>
        <CardFooter className="text-muted">
          {parseInt(currentStep) !== 1 ? (
            <ButtonToggle color="secondary" onClick={goToPreviousStep}>
              {'Back'}
            </ButtonToggle>
          ) : (
            ''
          )}
          {parseInt(currentStep) !== 5 && parseInt(currentStep) !== 6 ? (
            <ButtonToggle
              type="submit"
              color="primary"
              style={{ float: 'right' }}
              form={`form_step_${currentStep}`}
              disabled={loading}
            >
              {'Save & Next'}
            </ButtonToggle>
          ) : (
            ''
          )}
          {parseInt(currentStep) === 5 || parseInt(currentStep) === 6 ? (
            <ButtonToggle
              onClick={submitDocumentToAdmin}
              color="primary"
              style={{ float: 'right' }}
            >
              Submit To Admin
            </ButtonToggle>
          ) : (
            ''
          )}
        </CardFooter>
      </Card>
      {isDocumentEditFlow && currentStep !== 1 && (
        <Card
          className="p-1"
          body
          inverse
          style={{
            backgroundColor: '#1b3e6f',
            borderColor: '#333',
            width: 'fit-content',
            // bottom: "62px",
            position: 'fixed',
            right: '48px',
            top: '40%',
            //top: isExpandedFeeView ? "auto" : "35rem",
          }}
        >
          <CardTitle
            className="m-0"
            style={{ color: '#fff', textAlign: 'center' }}
          >
            <Button
              className="fee-details-arrow"
              color="primary"
              onClick={feeDetailsToggle}
            >
              {isExpandedFeeView ? (
                <i className="fas fa-dollar-sign p-0" />
              ) : (
                <i className="fas fa-dollar-sign p-0" />
              )}
            </Button>
          </CardTitle>
          {isExpandedFeeView ? (
            <CardText>
              <Table responsive hover className="fee-details-table">
                <tbody>
                  <tr>
                    <td>Document Fee</td>
                    <td>
                      $
                      {serviceAmount && serviceAmount > 0
                        ? parseFloat(serviceAmount).toFixed(2)
                        : 0}
                    </td>
                  </tr>
                  {groupedVariablesArray.map(
                    ({ variableLabel, variableFee }) => (
                      <tr>
                        <td>{variableLabel}</td>
                        <td>${parseFloat(variableFee).toFixed(2)}</td>
                      </tr>
                    )
                  )}
                  {groupedWebFormVariablesArray.map(({ label }) => {
                    const amount = label.match(/\d+/g) || 0.0;
                    return (
                      <tr>
                        <td>{label}</td>
                        <td>${parseFloat(amount).toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </CardText>
          ) : (
            ''
          )}
        </Card>
      )}
    </Fragment>
  );
}
const getState = ({
  CreateDocumentForm,
  HandleDocumentType,
  HandleDocumentFormat,
}) => {
  return {
    CreateDocumentForm,
    HandleDocumentType,
    HandleDocumentFormat,
  };
};
const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      //
    },
    dispatch
  ),
  dispatch,
});

export default connect(getState, mapDispatchToProps)(CreateDocument);
